import type { BillingStripeNotificationModalProps } from "@v2/types/modalTypes";

import * as React from "react";

import { Button } from "@replohq/lattice/components/button/Button";
import { Modal } from "@replohq/lattice/components/modal/Modal";

export const BillingStripeNotificationModal: React.FC<
  BillingStripeNotificationModalProps & {
    open: boolean;
    onOpenChange: (open: boolean) => void;
  }
> = ({ buttonText, onConfirm, open, onOpenChange }) => {
  const [isLoading, setIsLoading] = React.useState(false);

  const onClick = () => {
    setIsLoading(true);
    onConfirm();
  };

  return (
    <Modal
      open={open}
      title="Welcome to a New Billing Portal"
      onOpenChange={onOpenChange}
      footer={
        <Button
          variant="primary"
          size="base"
          onClick={onClick}
          loading={isLoading}
        >
          {buttonText}
        </Button>
      }
    >
      <div className="flex flex-col gap-4">
        To enhance your Replo experience, we've transitioned to a new billing
        portal that offers:
        <ul className="list-disc space-y-2 pl-5">
          <li>
            <span className="font-bold">Enhanced Security</span> - Payment
            information is safer
          </li>
          <li>
            <span className="font-bold">Full Control</span> - Easily upgrade or
            downgrade
          </li>
          <li>
            <span className="font-bold">Clear Visibility</span> - Understand
            exactly how and when you are billed
          </li>
          <li>
            <span className="font-bold">Direct Support</span> - Work directly
            with the Replo team for any billing issues
          </li>
        </ul>
        Please Note: You'll need to input your payment information again in the
        new portal. Your current plan billed through Shopify will be
        discontinued and a prorated refund will be issued.
      </div>
    </Modal>
  );
};
